interface Props {
  activeTab: 'members' | 'instruments' | 'roles';
  onTabChange: (tab: 'members' | 'instruments' | 'roles') => void;
  teamName: string;
}

const links = [
  { id: 'members' as const, label: 'Membros', icon: 'ri-group-line' },
  { id: 'instruments' as const, label: 'Instrumentos', icon: 'ri-music-2-line' },
  { id: 'roles' as const, label: 'Papéis', icon: 'ri-shield-user-line' },
];

export default function TeamSidebar({ activeTab, onTabChange, teamName }: Props) {
  return (
    <div className="w-full md:w-56 border-b md:border-b-0 md:border-r border-white/5 bg-[#0D0C09] flex flex-col flex-shrink-0">
      <div className="hidden md:block px-5 py-5 border-b border-white/5">
        <h2
          className="text-white font-semibold text-sm"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Equipe
        </h2>
        <p className="text-white/30 text-xs mt-1 truncate">{teamName}</p>
      </div>
      <nav className="flex md:flex-col py-1 md:py-3">
        {links.map((link) => {
          const active = activeTab === link.id;
          return (
            <button
              key={link.id}
              onClick={() => onTabChange(link.id)}
              className={`flex-1 md:flex-none flex items-center justify-center md:justify-start gap-2 md:gap-3 px-2 md:px-5 py-3 text-xs md:text-sm cursor-pointer transition-colors whitespace-nowrap text-left ${
                active
                  ? 'text-[#C8A96E] bg-[#C8A96E]/5 border-b-2 md:border-b-0 md:border-r-2 border-[#C8A96E]'
                  : 'text-white/50 hover:text-white hover:bg-white/[0.03]'
              }`}
            >
              <i className={`${link.icon} text-sm`}></i>
              {link.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
